import * as qinit from '../qinit';

export const PLATFORM_CHROMEBOOK = 'chromebook';

export const getMobileClientCredentials = () => mobileClientCredentials;
export const mobileClientCredentials = {
  client_id: qinit.tenant.mobile.server.client_id,
  client_secret: qinit.tenant.mobile.server.client_secret,
};

export const getClientCredentials = () => extensionCredentials;

export const extensionCredentials = {
  client_id: qinit.tenant.parents_app.platforms.chromebook.client_id,
  client_secret: qinit.tenant.parents_app.platforms.chromebook.client_secret,
  redirect_uri: qinit.tenant.parents_app.platforms.chromebook.redirect_uri,
};

export const getExtensionClientCredentials = () => extensionCredentials;

export const getSegmentKey = () => qinit.tenant.chromebook.segment.key;

export const getSegmentDefaultUser = () =>
  qinit.tenant.common.segment.default_user_id;

export enum OnboardingTrackingPages {
  COMPLETE_PROTECTION = 'Viewed Onboarding Complete Protection Screen',
  SETUP_SUCCESSFUL = 'Viewed Onboarding Setup Successful Screen',
}

export enum OnboardingTrackingEvents {
  CONNECT_ATTEMPT_STARTED = 'Clicked Onboarding Connect Now',
  CONNECT_ATTEMPT_FAILED = 'Viewed Onboarding Complete Protection Screen Error',
}

// The API side considers 1440 minutes (all day) as unlimited quota.
// This is helpful to avoid corner cases where multiple devices are reporting activity during the day.
export const UNLIMITED_DAILY_QUOTA = 1440;

export const getDownloadUrl = () =>
  qinit.tenant.common.downloads.chrome_extension;

export const TAMPERING_EVENT_NAME = 'Chrome Extension Tampered';
export const TAMPERING_CHECK_POLLING_INTERVAL = 1500;

export const getSetupIntentUrl = () =>
  `intent://chrome-extension#Intent;scheme=qustodio;` +
  `package=${qinit.tenant.mobile.platform_application_id.android_package_name};end`;

export const EXTENSION_SETUP_INTENT_TIMEOUT = 10000;

export const getSetupIntentTimeout = () => EXTENSION_SETUP_INTENT_TIMEOUT;

export const getOnboardingHelpTip = () =>
  qinit.tenant.marketing.public_site.general_help_link;

export const getEnvironment = () => qinit.env;

export const getSentryDSN = () => qinit.tenant.chromebook.sentry.dsn;

export const getTenantName = () => qinit.tenant.common.tenant.name;

export const getLinewizeBlockPagesHosts = (): string[] =>
  qinit.tenant.common.delegation.linewize_block_pages_host_regexes;

export const CHROMEBOOK_OS_DEVICE_TYPE = 'LAPTOP';

export const CHROMEBOOK_OS_DEVICE_PLATFORM = 5;

export const CHROMEBOOK_OS_DEVICE_UNAME = 'user';

export const CHROMEBOOK_OS_DEVICE_UUID = 1;
